import { useCallback, useEffect, useRef, useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { useBatchStatusUpdates, wsClient } from '@tankef/websocket';

export function useBatchTransferRealtime(id: string | undefined, enabled = true) {
  const queryClient = useQueryClient();
  const [liveBatchId, setLiveBatchId] = useState<string>();
  const expiry = useRef<ReturnType<typeof setTimeout>>();
  const handleUpdate = useCallback(() => {
    if (!id) return;
    setLiveBatchId(id);
    clearTimeout(expiry.current);
    expiry.current = setTimeout(() => setLiveBatchId(undefined), 10000);
    void queryClient.invalidateQueries({ queryKey: ['batch-transfers', id] });
    void queryClient.invalidateQueries({ queryKey: ['batch-transfers', id, 'results'] });
  }, [id, queryClient]);
  useEffect(() => () => clearTimeout(expiry.current), []);
  useBatchStatusUpdates(id, handleUpdate, enabled);
  return { live: enabled && Boolean(id) && liveBatchId === id && wsClient.isConnected() };
}
